var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('div',{staticClass:"container container-sm flex-shrink-0 pt-3 pb-3 position-relative"},[_c('change-password-form',{staticStyle:{"max-width":"500px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }